import React from 'react';

function MarketUpdates() {
  return (
    <div className="marketUpdates">
    </div>
  );
}

export default MarketUpdates;